import { render, staticRenderFns } from "./MidwifeMasterdataOverview.vue?vue&type=template&id=55b4cde6"
import script from "./MidwifeMasterdataOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeMasterdataOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports